module.exports = __webpack_public_path__ + "img/numero-da-sorte.30693b58.png";